<script setup>
import {inject, defineEmits, ref, computed} from 'vue';
import {XCircleIcon} from '@heroicons/vue/24/outline';

const props = defineProps({
    modalClass: {
        type: String,
        required: false,
        default: 'xl:max-w-3xl',
    },
    modalTitle: {
        type: String,
        required: false,
        default: 'Edit Record',
    },
});

const modalEditState = inject('modalEditState');
const emit = defineEmits([

]);

const handleEvent = (eventName, ...args) => {
    if (modalEditState.callback && typeof modalEditState.callback[eventName] === 'function') {
        modalEditState.callback[eventName](...args);
    }
};


const handleTableRecordAdded = (newTableRecord) => {
    if (typeof modalEditState.callback === 'function') {
        modalEditState.callback(newTableRecord);
    }
    modalEditState.close(); // Optionally close the modal after handling the event
};

const modalClass = computed(() => modalEditState.props.modalClass ?? 'xl:max-w-3xl');
const modalTitle = computed(() => modalEditState.props.modalTitle ?? props.modalTitle ?? 'Edit Record');


</script>

<template>
    <Transition>
        <div id="modal" v-if="modalEditState.isVisible" class="modal">
            <div class="backdrop inset-0 z-1000 bg-violet/75 fixed top-0 left-0 w-screen h-screen">

            </div>

            <div class="fixed inset-0 z-1100 top-0 left-0 w-screen h-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <div
                        :class="['relative transform overflow-hidden rounded-xl bg-white text-left shadow-xl  transition-all sm:my-8 sm:w-full sm:max-w-lg', modalClass]">
                        <div
                            class="modal-header bg-primary-1 text-white text-center text-4xl font-bold py-8 lg:py-12 px-6 lg:px-12 leading-tight">
                            {{ modalTitle }}
                            <button @click="modalEditState.isVisible = !modalEditState.isVisible"
                                    class="p-1 text-white font-bold leading-tight absolute right-2 top-2">
                                <div class="w-10 hover:scale-125 hover:text-white transition-all duration-500">
                                    <x-circle-icon></x-circle-icon>
                                </div>
                            </button>
                        </div>
                        <div class="modal-content bg-white p-6 lg:p-12"
                        data-target="replace-with-content">
                            <component
                                :is="modalEditState.component"
                                v-bind="modalEditState.props"
                                @user-added="handleTableRecordAdded"
                                @division-added="handleTableRecordAdded"
                                @productivity-report-added="handleTableRecordAdded"

                                @report-form-setup-added="handleTableRecordAdded"
                                @report-form-detail-added="handleTableRecordAdded"

                                @research-section-added="handleTableRecordAdded"
                                @research-setup-added="handleTableRecordAdded"
                                @research-detail-added="handleTableRecordAdded"

                                @unit-added="handleTableRecordAdded"
                                @role-added="handleTableRecordAdded"
                                @role-detail-added="handleTableRecordAdded"
                                @role-line-added="handleTableRecordAdded"
                                @productivity-report-type-added="handleTableRecordAdded"

                                @save-and-submit="handleTableRecordAdded"
                                @close-thank-you-modal="handleTableRecordAdded"

                                @close-modal="modalEditState.isVisible = !modalEditState.isVisible"
                            ></component>
                        </div>
                        <div class="modal-footer bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 justify-center">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>

</template>

<style scoped>
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }
</style>
